import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=912ff20a&scoped=true&"
import script from "./LanguagePicker.vue?vue&type=script&lang=js&"
export * from "./LanguagePicker.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=912ff20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ff20a",
  null
  
)

export default component.exports